import Q from 'q';

import API from 'js/lib/api';
import user from 'js/lib/user';

const onDemandAssignmentStaffStepActions = API('/api/onDemandAssignmentStaffStepActions.v1', { type: 'rest' });

export const deleteAttempt = (userId: number | string, itemId: string, courseId: string) => {
  return Q(
    onDemandAssignmentStaffStepActions.post('', {
      data: {
        courseId,
        itemId,
        userId: Number(userId),
        actorUserId: user.get().id,
        stepId: 'SUBMITTER_SUBMISSION',
        action: {
          typeName: 'deleteDraft',
          definition: {},
        },
      },
    })
  );
};
